export default "__VITE_ASSET__qD_2cKq5__"